export const shouldLoad = () => document.querySelector('[data-controller="job-section"]') !== undefined;